(() => {
  // Keep original application controls in sync with the canonical Shopify form.
  const sync = () => {
    const form = document.querySelector('product-form.main-product-form form[action*="/cart/add"]');
    const variant = form?.querySelector('input[name="id"]')?.value;
    if (!variant || !/^\d+$/.test(variant)) return;
    document.querySelectorAll('.yx-main-product-page [data-variant-id]').forEach(button => {
      if (button.dataset.variantId !== variant) button.dataset.variantId = variant;
    });
  };
  document.addEventListener('change', () => { sync(); setTimeout(sync, 150); setTimeout(sync, 650); });
  document.addEventListener('variant:change',sync);
  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('DOMContentLoaded',sync);
  sync();
})();
